import { render, staticRenderFns } from "./Comple.vue?vue&type=template&id=c2094600&scoped=true&"
import script from "./Comple.vue?vue&type=script&lang=ts&"
export * from "./Comple.vue?vue&type=script&lang=ts&"
import style0 from "./Comple.vue?vue&type=style&index=0&id=c2094600&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2094600",
  null
  
)

export default component.exports